'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _resetForm = require('../helpers/resetForm');

var _resetForm2 = _interopRequireDefault(_resetForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resetFormFactory(formPath) {
  function resetForm(_ref) {
    var state = _ref.state,
        resolve = _ref.resolve;

    if (!resolve.isTag(formPath, 'state')) {
      throw new Error('Cerebral Forms - operator.resetForm: You have to use the STATE TAG as an argument');
    }

    var path = resolve.path(formPath);

    state.set(path, (0, _resetForm2.default)(state.get(path)));
  }

  return resetForm;
}

exports.default = resetFormFactory;
//# sourceMappingURL=resetForm.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/forms/lib/operators/resetForm.js
// module id = 1008
// module chunks = 5